import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

function uid() {
    return Math.random().toString(36).substring(2);
}
class ContentLoaderComponent {
    constructor() {
        this.fixedId = uid();
        this.idClip = `${this.fixedId}-diff`;
        this.idGradient = `${this.fixedId}-animated-diff`;
        this.idAria = `${this.fixedId}-aria`;
        this.animate = true;
        this.baseUrl = '';
        this.speed = 1.2;
        this.viewBox = '0 0 400 130';
        this.gradientRatio = 2;
        this.backgroundColor = '#f5f6f7';
        this.backgroundOpacity = 1;
        this.foregroundColor = '#eee';
        this.foregroundOpacity = 1;
        this.rtl = false;
        this.interval = 0.25;
        this.style = {};
        this.animationValues = [];
    }
    ngOnInit() {
        this.clipPath = `url(${this.baseUrl}#${this.idClip})`;
        this.fillStyle = { fill: `url(${this.baseUrl}#${this.idGradient})` };
        this.style = this.rtl ? { ...this.style, ...{ transform: 'scaleX(-1)' } } : this.style;
        this.duration = `${this.speed}s`;
        this.keyTimes = `0; ${this.interval}; 1`;
        this.animationValues = [
            `${-this.gradientRatio}; ${-this.gradientRatio}; 1`,
            `${-this.gradientRatio / 2}; ${-this.gradientRatio / 2}; ${1 + this.gradientRatio / 2}`,
            `0; 0; ${1 + this.gradientRatio}`
        ];
    }
}
/** @nocollapse */ /** @nocollapse */ ContentLoaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: ContentLoaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ /** @nocollapse */ ContentLoaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.0.1", type: ContentLoaderComponent, selector: "content-loader", inputs: { animate: "animate", baseUrl: "baseUrl", speed: "speed", viewBox: "viewBox", gradientRatio: "gradientRatio", backgroundColor: "backgroundColor", backgroundOpacity: "backgroundOpacity", foregroundColor: "foregroundColor", foregroundOpacity: "foregroundOpacity", rtl: "rtl", interval: "interval", style: "style" }, ngImport: i0, template: "<svg [attr.viewBox]=\"viewBox\" [ngStyle]=\"style\">\n  <rect role=\"presentation\" [attr.clip-path]=\"clipPath\" [ngStyle]=\"fillStyle\" x=\"0\" y=\"0\" width=\"100%\" height=\"100%\" />\n\n  <defs role=\"presentation\">\n    <clipPath [attr.id]=\"idClip\">\n      <ng-content></ng-content>\n    </clipPath>\n\n    <linearGradient [attr.id]=\"idGradient\">\n      <stop offset=\"0%\" [attr.stop-color]=\"backgroundColor\" [attr.stop-opacity]=\"backgroundOpacity\">\n        <animate\n          *ngIf=\"animate\"\n          [attr.keyTimes]=\"keyTimes\"\n          attributeName=\"offset\"\n          [attr.values]=\"animationValues[0]\"\n          [attr.dur]=\"duration\"\n          repeatCount=\"indefinite\"\n        />\n      </stop>\n\n      <stop offset=\"50%\" [attr.stop-color]=\"foregroundColor\" [attr.stop-opacity]=\"foregroundOpacity\">\n        <animate\n          *ngIf=\"animate\"\n          attributeName=\"offset\"\n          [attr.keyTimes]=\"keyTimes\"\n          [attr.values]=\"animationValues[1]\"\n          [attr.dur]=\"duration\"\n          repeatCount=\"indefinite\"\n        />\n      </stop>\n\n      <stop offset=\"100%\" [attr.stop-color]=\"backgroundColor\" [attr.stop-opacity]=\"backgroundOpacity\">\n        <animate\n          *ngIf=\"animate\"\n          attributeName=\"offset\"\n          [attr.keyTimes]=\"keyTimes\"\n          [attr.values]=\"animationValues[2]\"\n          [attr.dur]=\"duration\"\n          repeatCount=\"indefinite\"\n        />\n      </stop>\n    </linearGradient>\n  </defs>\n</svg>\n", styles: [":host{display:block}\n"], directives: [{ type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: ContentLoaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'content-loader', changeDetection: ChangeDetectionStrategy.OnPush, styles: [
                        `
      :host {
        display: block;
      }
    `
                    ], template: "<svg [attr.viewBox]=\"viewBox\" [ngStyle]=\"style\">\n  <rect role=\"presentation\" [attr.clip-path]=\"clipPath\" [ngStyle]=\"fillStyle\" x=\"0\" y=\"0\" width=\"100%\" height=\"100%\" />\n\n  <defs role=\"presentation\">\n    <clipPath [attr.id]=\"idClip\">\n      <ng-content></ng-content>\n    </clipPath>\n\n    <linearGradient [attr.id]=\"idGradient\">\n      <stop offset=\"0%\" [attr.stop-color]=\"backgroundColor\" [attr.stop-opacity]=\"backgroundOpacity\">\n        <animate\n          *ngIf=\"animate\"\n          [attr.keyTimes]=\"keyTimes\"\n          attributeName=\"offset\"\n          [attr.values]=\"animationValues[0]\"\n          [attr.dur]=\"duration\"\n          repeatCount=\"indefinite\"\n        />\n      </stop>\n\n      <stop offset=\"50%\" [attr.stop-color]=\"foregroundColor\" [attr.stop-opacity]=\"foregroundOpacity\">\n        <animate\n          *ngIf=\"animate\"\n          attributeName=\"offset\"\n          [attr.keyTimes]=\"keyTimes\"\n          [attr.values]=\"animationValues[1]\"\n          [attr.dur]=\"duration\"\n          repeatCount=\"indefinite\"\n        />\n      </stop>\n\n      <stop offset=\"100%\" [attr.stop-color]=\"backgroundColor\" [attr.stop-opacity]=\"backgroundOpacity\">\n        <animate\n          *ngIf=\"animate\"\n          attributeName=\"offset\"\n          [attr.keyTimes]=\"keyTimes\"\n          [attr.values]=\"animationValues[2]\"\n          [attr.dur]=\"duration\"\n          repeatCount=\"indefinite\"\n        />\n      </stop>\n    </linearGradient>\n  </defs>\n</svg>\n" }]
        }], propDecorators: { animate: [{
                type: Input
            }], baseUrl: [{
                type: Input
            }], speed: [{
                type: Input
            }], viewBox: [{
                type: Input
            }], gradientRatio: [{
                type: Input
            }], backgroundColor: [{
                type: Input
            }], backgroundOpacity: [{
                type: Input
            }], foregroundColor: [{
                type: Input
            }], foregroundOpacity: [{
                type: Input
            }], rtl: [{
                type: Input
            }], interval: [{
                type: Input
            }], style: [{
                type: Input
            }] } });

class BulletListContentLoaderComponent extends ContentLoaderComponent {
}
/** @nocollapse */ /** @nocollapse */ BulletListContentLoaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: BulletListContentLoaderComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ /** @nocollapse */ BulletListContentLoaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.0.1", type: BulletListContentLoaderComponent, selector: "bullet-list-content-loader", usesInheritance: true, ngImport: i0, template: `
    <content-loader viewBox="0 0 245 125">
      <svg:circle cx="10" cy="20" r="8" />
      <svg:rect x="25" y="15" rx="5" ry="5" width="220" height="10" />
      <svg:circle cx="10" cy="50" r="8" />
      <svg:rect x="25" y="45" rx="5" ry="5" width="220" height="10" />
      <svg:circle cx="10" cy="80" r="8" />
      <svg:rect x="25" y="75" rx="5" ry="5" width="220" height="10" />
      <svg:circle cx="10" cy="110" r="8" />
      <svg:rect x="25" y="105" rx="5" ry="5" width="220" height="10" />
    </content-loader>
  `, isInline: true, components: [{ type: ContentLoaderComponent, selector: "content-loader", inputs: ["animate", "baseUrl", "speed", "viewBox", "gradientRatio", "backgroundColor", "backgroundOpacity", "foregroundColor", "foregroundOpacity", "rtl", "interval", "style"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: BulletListContentLoaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bullet-list-content-loader',
                    template: `
    <content-loader viewBox="0 0 245 125">
      <svg:circle cx="10" cy="20" r="8" />
      <svg:rect x="25" y="15" rx="5" ry="5" width="220" height="10" />
      <svg:circle cx="10" cy="50" r="8" />
      <svg:rect x="25" y="45" rx="5" ry="5" width="220" height="10" />
      <svg:circle cx="10" cy="80" r="8" />
      <svg:rect x="25" y="75" rx="5" ry="5" width="220" height="10" />
      <svg:circle cx="10" cy="110" r="8" />
      <svg:rect x="25" y="105" rx="5" ry="5" width="220" height="10" />
    </content-loader>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }] });

class FacebookContentLoaderComponent extends ContentLoaderComponent {
}
/** @nocollapse */ /** @nocollapse */ FacebookContentLoaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: FacebookContentLoaderComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ /** @nocollapse */ FacebookContentLoaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.0.1", type: FacebookContentLoaderComponent, selector: "facebook-content-loader", usesInheritance: true, ngImport: i0, template: `
    <content-loader viewBox="0 0 476 124">
      <svg:rect x="48" y="8" width="88" height="6" rx="3" />
      <svg:rect x="48" y="26" width="52" height="6" rx="3" />
      <svg:rect x="0" y="56" width="410" height="6" rx="3" />
      <svg:rect x="0" y="72" width="380" height="6" rx="3" />
      <svg:rect x="0" y="88" width="178" height="6" rx="3" />
      <svg:circle cx="20" cy="20" r="20" />
    </content-loader>
  `, isInline: true, components: [{ type: ContentLoaderComponent, selector: "content-loader", inputs: ["animate", "baseUrl", "speed", "viewBox", "gradientRatio", "backgroundColor", "backgroundOpacity", "foregroundColor", "foregroundOpacity", "rtl", "interval", "style"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: FacebookContentLoaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'facebook-content-loader',
                    template: `
    <content-loader viewBox="0 0 476 124">
      <svg:rect x="48" y="8" width="88" height="6" rx="3" />
      <svg:rect x="48" y="26" width="52" height="6" rx="3" />
      <svg:rect x="0" y="56" width="410" height="6" rx="3" />
      <svg:rect x="0" y="72" width="380" height="6" rx="3" />
      <svg:rect x="0" y="88" width="178" height="6" rx="3" />
      <svg:circle cx="20" cy="20" r="20" />
    </content-loader>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }] });

class ListContentLoaderComponent extends ContentLoaderComponent {
}
/** @nocollapse */ /** @nocollapse */ ListContentLoaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: ListContentLoaderComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ /** @nocollapse */ ListContentLoaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.0.1", type: ListContentLoaderComponent, selector: "list-content-loader", usesInheritance: true, ngImport: i0, template: `
    <content-loader viewBox="0 0 400 110">
      <svg:rect x="0" y="0" rx="3" ry="3" width="250" height="10" />
      <svg:rect x="20" y="20" rx="3" ry="3" width="220" height="10" />
      <svg:rect x="20" y="40" rx="3" ry="3" width="170" height="10" />
      <svg:rect x="0" y="60" rx="3" ry="3" width="250" height="10" />
      <svg:rect x="20" y="80" rx="3" ry="3" width="200" height="10" />
      <svg:rect x="20" y="100" rx="3" ry="3" width="80" height="10" />
    </content-loader>
  `, isInline: true, components: [{ type: ContentLoaderComponent, selector: "content-loader", inputs: ["animate", "baseUrl", "speed", "viewBox", "gradientRatio", "backgroundColor", "backgroundOpacity", "foregroundColor", "foregroundOpacity", "rtl", "interval", "style"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: ListContentLoaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'list-content-loader',
                    template: `
    <content-loader viewBox="0 0 400 110">
      <svg:rect x="0" y="0" rx="3" ry="3" width="250" height="10" />
      <svg:rect x="20" y="20" rx="3" ry="3" width="220" height="10" />
      <svg:rect x="20" y="40" rx="3" ry="3" width="170" height="10" />
      <svg:rect x="0" y="60" rx="3" ry="3" width="250" height="10" />
      <svg:rect x="20" y="80" rx="3" ry="3" width="200" height="10" />
      <svg:rect x="20" y="100" rx="3" ry="3" width="80" height="10" />
    </content-loader>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }] });

class ContentLoaderModule {
    static forRoot() {
        return {
            ngModule: ContentLoaderModule
        };
    }
}
/** @nocollapse */ /** @nocollapse */ ContentLoaderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: ContentLoaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ /** @nocollapse */ ContentLoaderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: ContentLoaderModule, declarations: [ContentLoaderComponent,
        FacebookContentLoaderComponent,
        BulletListContentLoaderComponent,
        ListContentLoaderComponent], imports: [CommonModule], exports: [ContentLoaderComponent,
        FacebookContentLoaderComponent,
        BulletListContentLoaderComponent,
        ListContentLoaderComponent] });
/** @nocollapse */ /** @nocollapse */ ContentLoaderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: ContentLoaderModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: ContentLoaderModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [
                        ContentLoaderComponent,
                        FacebookContentLoaderComponent,
                        BulletListContentLoaderComponent,
                        ListContentLoaderComponent
                    ],
                    exports: [
                        ContentLoaderComponent,
                        FacebookContentLoaderComponent,
                        BulletListContentLoaderComponent,
                        ListContentLoaderComponent
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { BulletListContentLoaderComponent, ContentLoaderComponent, ContentLoaderModule, FacebookContentLoaderComponent, ListContentLoaderComponent };
